function cov_2m9cmq3phi() {
  var path = "/app/src/components/learn-more-with-schedule/index.tsx";
  var hash = "0b542a554dd037971c2e42f60471bbd9d3d56b6c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/learn-more-with-schedule/index.tsx",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0b542a554dd037971c2e42f60471bbd9d3d56b6c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2m9cmq3phi = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2m9cmq3phi();
export { LearnMoreWithSchedule } from './learn-more-with-schedule';